import { gql } from '@apollo/client'

import { FRAGMENT as STUDENT_WORK_FRAGMENT } from 'src/components/StudentWorkCard'

// export const PAGES = gql`
//   query HallOfHameHome_pages($page: Int, $perPage: Int, $type: HallOfFamerType) {
//     hallOfFamers(page: $page, perPage: $perPage, type: $type) {
//     }
//   }
// `

export default gql`
  query HallOfFameHome($page: Int, $perPage: Int, $type: HallOfFamerType) {
    hallOfFamers(page: $page, perPage: $perPage, type: $type) {
      nodes {
        ...StudentWorkCardComponent
      }
      totalCount
      pageInfo {
        hasNextPage
        totalCount
      }
    }
  }

  ${STUDENT_WORK_FRAGMENT}
`
